module.exports = __webpack_public_path__ + "img/인덕원 미용실 2.26cf636a.png";